/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import WorkFlowStepLog from './work-flow-step-log';
import WorkFlowStepLogDetail from './work-flow-step-log-detail';
import WorkFlowStepLogUpdate from './work-flow-step-log-update';
import WorkFlowStepLogDeleteDialog from './work-flow-step-log-delete-dialog';

const WorkFlowStepLogRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<WorkFlowStepLog />} />
    <Route path="new" element={<WorkFlowStepLogUpdate />} />
    <Route path=":id">
      <Route index element={<WorkFlowStepLogDetail />} />
      <Route path="edit" element={<WorkFlowStepLogUpdate />} />
      <Route path="delete" element={<WorkFlowStepLogDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default WorkFlowStepLogRoutes;
